import { Routes } from '@angular/router';
import { tradeOptionDetailsRoutes } from './trade-option-details/trade-option-details.routes';

export const tradeOptionsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./trade-options.page').then((m) => m.TradeOptionsPage),
  },
  {
    path: ':agent_id/:col_id/:user_col_id',
    loadComponent: () =>
      import('./trade-options.page').then((m) => m.TradeOptionsPage),
  },
  {
    path: 'trade-option-details/:targetAgentId',
    children: tradeOptionDetailsRoutes,
  },
];
